import { Component, Prop } from 'vue-property-decorator'
import ClvrComponent from '../../../../../system/vue/Core/ClvrComponent'
import { KhText, KhSwitch, Nullable } from '@internal-libraries/kheops-ui-lib'
import { ClvrScreenControlHeadersInterface } from '../../ClvrScreenControlPlanningTable/interface'
import { MappingAdditionalDataTemplateDto } from '../../../Types/MappingAdditionalDataTemplateDto'
import ClvrScreenControlTable from '../../ClvrScreenControlPlanningTable/ClvrScreenControlTable/ClvrScreenControlTable.vue'

@Component({
    components: {
        ClvrScreenControlTable,
        KhText,
        KhSwitch,
    },
})
export default class ClvrScreenControlTemplateListDataTypeHeaders extends ClvrComponent {
    @Prop({ type: String, default: null })
    public classTr!: Nullable<string>
    @Prop({ type: Array, default: [] })
    public headers!: ClvrScreenControlHeadersInterface[]
    @Prop({ type: Array, default: [] })
    public datas!: MappingAdditionalDataTemplateDto[]

    public get hasColumn(): boolean {
        return true //this.headers.filter(header => header.enable).length > 0
    }
}
